import React from 'react';
import onClickOutside from 'react-onclickoutside';
import { AiNotesProps } from '../../../types/sidePanel.types';
import { WbMarkdownHtml } from '../../../../utils/common';
import CKEditor from './CKEditorComponent';
import debounce from 'lodash/debounce'

export default onClickOutside(
  class AiNotesComp extends React.Component<AiNotesProps, {notesData: any, editorActive: boolean}> {
    constructor (props: AiNotesProps) {
      super(props);
      this.state = {
        notesData: this.props.notes,
        editorActive: false
      }
    }

    delayedCalleback = debounce(function () {
      this.props.saveAiNote(this.state.notesData);
    }, 1000)

    handleClickOutside = () => {
      const linkForm = document.querySelector('.ck-balloon-panel');
      if (!linkForm) return;

      const isOpenLinkForm = linkForm.classList.contains('ck-balloon-panel_visible');
      if (isOpenLinkForm) {
        return;
      }

      if (this.state.editorActive) {
        this.setState({ editorActive: false });
        this.props.saveAiNote(this.state.notesData);
      }
    }

    handleChange = (notesData) => {
      this.setState({ notesData });
      this.delayedCalleback();
    }

    handleTextAreaClick = () => {
      this.setState({ editorActive: true });
    };

    render () {
      const style = {
        width: '99%',
        height: '99%',
        border: 'none',
        minHeight: '220px',
        wordBreak: 'break-word'
      }
      const { aiId, descAccess, editorConfiguration } = this.props;
      const textId: any = `wsBoardNotesEditor_${aiId}`;
      const disableNotes: any = descAccess ? {} : { disabled: 'disabled' };
      const divStyle = {
        padding: '5px'
      };
      const { editorActive, notesData } = this.state;

      return (
        <div className="wsBoardAiNotesWrapperDiv" data-id={aiId} style={editorActive ? {} : divStyle}>
          {editorActive ? (
            <CKEditor
              data={notesData}
              onChange={this.handleChange}
              editorConfiguration={editorConfiguration}
            />
          ) : (
            <div
              dangerouslySetInnerHTML={WbMarkdownHtml(notesData, true)}
              id={textId}
              {...disableNotes}
              value={notesData || ''}
              defaultValue={notesData || ''}
              onClick={this.handleTextAreaClick}
              style={style}
            />
          )}
        </div>
      );
    }
  }
);
